module.exports = __webpack_public_path__ + "img/316513216513.999849aa.png";